export function processError(errorResponse: any) {
  let code: string
  if (errorResponse.status === 404) code = "utils_server_empty"
  else if (errorResponse.status >= 500) code = "utils_network_error"
  else if (errorResponse.status === 403) code = "utils_server_unauthorized"
  else code = errorResponse.data.error
  return code
}
